import type { ReactNode } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router";
import { toaster } from "@/app";
import { authClient } from "@/lib/auth-client";
import { homePathFor, isStaffRole } from "@/lib/home-path";

/**
 * Guards ChantierCarré back-office routes (/staff/*).
 * Staff = root or admin; other roles are sent back to their own home.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const session = authClient.useSession();

  const role = session.data?.user?.role;
  const isStaff = isStaffRole(role);

  useEffect(() => {
    if (session.data && !isStaff) {
      toaster.create({
        title: "Page inaccessible",
        description:
          "Cette page est réservée aux comptes ChantierCarré. Retour à votre page d'accueil.",
        type: "error",
      });
    }
  }, [session.data, isStaff]);

  if (!session.data) {
    return null;
  }

  if (!isStaff) {
    return <Navigate to={homePathFor(role)} replace />;
  }

  return <>{children}</>;
}
